import type { Variants } from "motion/react";

export const CHANNEL_MODAL_STEP_S = 0.18;
export const CHANNEL_MODAL_STEP_OFFSET_PX = 6;

const EASE = [0.22, 1, 0.36, 1] as const;

/** Picker to channel intro. Opacity plus a few pixels; connect stays on the click. */
export function channelModalStepMotion(reduceMotion: boolean): Variants {
  if (reduceMotion) {
    return {
      initial: { opacity: 0 },
      animate: { opacity: 1, transition: { duration: 0 } },
      exit: { opacity: 0, transition: { duration: 0 } },
    };
  }

  return {
    initial: { opacity: 0, y: CHANNEL_MODAL_STEP_OFFSET_PX },
    animate: {
      opacity: 1,
      y: 0,
      transition: { duration: CHANNEL_MODAL_STEP_S, ease: EASE },
    },
    exit: {
      opacity: 0,
      y: CHANNEL_MODAL_STEP_OFFSET_PX,
      transition: { duration: CHANNEL_MODAL_STEP_S, ease: EASE },
    },
  };
}
